"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var LocalStorage = /** @class */ (function () {
    function LocalStorage(storage) {
        if (storage === void 0) { storage = window.localStorage; }
        this.storage = storage;
    }
    LocalStorage.prototype.get = function (key) {
        var rootRaw = this.storage.getItem(LocalStorage.ROOT_KEY);
        if (rootRaw === null) {
            this.install();
            rootRaw = this.storage.getItem(LocalStorage.ROOT_KEY);
        }
        var root = JSON.parse(rootRaw, this.dateReviver);
        if (root[key] === undefined)
            return null;
        return root[key];
    };
    LocalStorage.prototype.set = function (key, value) {
        try {
            var rootRaw = this.storage.getItem(LocalStorage.ROOT_KEY);
            if (rootRaw === null) {
                this.install();
                rootRaw = this.storage.getItem(LocalStorage.ROOT_KEY);
            }
            var root = JSON.parse(rootRaw, this.dateReviver);
            root[key] = value;
            this.storage.setItem(LocalStorage.ROOT_KEY, JSON.stringify(root));
        }
        catch (err) {
            console.log(err);
        }
    };
    LocalStorage.prototype.remove = function (key) {
        var rootRaw = this.storage.getItem(LocalStorage.ROOT_KEY);
        if (rootRaw === null)
            return;
        var root = JSON.parse(rootRaw, this.dateReviver);
        delete root[key];
        this.storage.setItem(LocalStorage.ROOT_KEY, JSON.stringify(root));
    };
    LocalStorage.prototype.clear = function () {
        this.storage.removeItem(LocalStorage.ROOT_KEY);
    };
    LocalStorage.prototype.install = function () {
        var root = {
            firstVisit: new Date(),
            impressions: [],
            conversions: [],
            rejections: [],
            browserID: (0, uuid_1.v4)(),
            rn: this.setRandomNumber()
        };
        this.storage.setItem(LocalStorage.ROOT_KEY, JSON.stringify(root));
    };
    LocalStorage.prototype.addMissingAttributes = function () {
        try {
            if (!this.get('rn'))
                this.set('rn', this.setRandomNumber());
        }
        catch (error) { }
    };
    LocalStorage.prototype.dateReviver = function (key, value) {
        // startswith: 2015-04-29T22:06:55
        var reDateDetect = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
        if (typeof value === 'string' && reDateDetect.exec(value)) {
            return new Date(value);
        }
        return value;
    };
    LocalStorage.prototype.setRandomNumber = function () {
        return Math.floor(Math.random() * 100) + 1;
    };
    LocalStorage.ROOT_KEY = 'socital';
    return LocalStorage;
}());
exports.default = LocalStorage;
//# sourceMappingURL=data:application/json;base64,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